/* eslint-disable react/require-default-props, jsx-a11y/label-has-for */
import PropTypes from 'prop-types';
import React from 'react';
import { fieldInputPropTypes, fieldMetaPropTypes } from 'redux-form';
import FaChevronDown from 'react-icons/lib/md/keyboard-arrow-down';
import cx from 'classnames';

import './Select.scss';

const InputSelect = ({
  required,
  input,
  inputID,
  label,
  labelClassName,
  inputClassName,
  autoFocus,
  disabled,
  defaultOptions,
  placeholder,
  hidden,
  meta: { touched, error, warning },

}) => {
  if (hidden) {
    return null;
  }
  const formErrorClass = 'form-group row';
  return (
    <div className={formErrorClass}>
      {label && (
        <label htmlFor={inputID} className={labelClassName}>
          {label}
          {required && <span className="requiredField ml-1">*</span>}
        </label>
      )}
      <div className={inputClassName}>
        <select
          className={cx('form-control form-control-lg', {
            'is-invalid': touched && error,
          })}
          {...input}
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus={autoFocus}
          id={inputID}
          disabled={disabled}
        >
          {placeholder && <option value="" disabled>{placeholder}</option>}
          {defaultOptions.map((el) => (
            <option key={el.value} value={el.value}>
              {el.label}
            </option>
          ))}
        </select>
        {(touched)
        && ((error && <div className="invalid-feedback">{error}</div>)
          || (warning && <div className="invalid-feedback invalid-feedback-warn">{warning}</div>))}
      </div>
    </div>
  );
};

InputSelect.propTypes = {
  input: PropTypes.shape(fieldInputPropTypes).isRequired,
  label: PropTypes.string,
  meta: PropTypes.shape(fieldMetaPropTypes).isRequired,
  autoFocus: PropTypes.bool,
  required: PropTypes.bool,
  inputID: PropTypes.string,
  placeholder: PropTypes.string,
  labelClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  disabled: PropTypes.bool,
  hidden: PropTypes.bool,
  defaultOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
  })),
};
InputSelect.defaultProps = {
  label: null,
  autoFocus: false,
  required: false,
  inputID: null,
  labelClassName: 'text-left col-12',
  inputClassName: 'col-12',
  disabled: false,
  defaultOptions: [],
  placeholder: null,
  hidden: false,
};

export default InputSelect;
